$(document).ready(function() {
  $('.aeo-register-section').click(function(){
      $('.register-login').show();
      $('.aeo-flex-banner .aeo-login-main').hide();
  });
  $('.login_text_bottom span').click(function(){
      $('.register-login').hide();
      $('.aeo-flex-banner .aeo-login-main').show();
  });
});

window.addEventListener('load', function() {
  const aeoVerifiedForm = document.getElementById('verify-form')
  aeoVerifiedForm && aeoVerifiedForm.addEventListener('submit', async function(e) {
    e.preventDefault();

    // const fullName = document.getElementById('customerName').value.trim();
    const storeNumber = document.getElementById('storeId').value.trim();
    const employeId = document.getElementById('employeeId').value.trim();
    const msg = document.getElementById('response-message');

    if (!employeId || !storeNumber) {
      msg.innerHTML = "❌ Please fill in all fields.";
      return;
    }
    const formData = new URLSearchParams();
    // formData.append("full_name", fullName);
    formData.append("store_number", storeNumber);
    formData.append("employee_id", employeId);

    try {
      document.getElementById('verify-form').querySelector('button').classList.add("loading");
      const response = await fetch("https://script.google.com/macros/s/AKfycbwxPaM2D1d7CjWFAPhixY1GDddscTKHofOLLaDdBz4qFXBPLjyVPPNkAjC7jMmA9ugFXw/exec", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: formData.toString()
      });
      const result = await response.json();

      console.log("AEO verification result:", result);

      msg.innerHTML = result.valid
        ? "✅ You're eligible! Please proceed."
        : "❌ " + result.message;
        document.getElementById('verify-form').querySelector('button').classList.remove("loading");

      const aeoData = JSON.stringify(result?.data);
      localStorage.setItem('aeo_verified', aeoData);

      if (result.valid) {
        // document.getElementById('verify-form').reset();
        setTimeout(() => {
          window.location.href = "/pages/aeo-activate";
        }, 1500);
      }

    } catch (error) {
      msg.innerHTML = "❌ Error validating data. Try again later.";
      console.error(error);
      document.getElementById('verify-form').querySelector('button').classList.remove("loading");
    }
  });
});